import moment from 'moment'
import Vue from 'vue';

Vue.filter('date', value => {
  if (value) {
    return moment(value).local().format('DD/MM/YYYY');
  }
});